
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import scroll from '@/mixins/scroll'
import editGoodsCard from '@/views/industryMall/goods/components/editGoodsCard.vue'
import customRadio from '@/views/industryMall/goods/components/customRadio.vue'
import { ShopGoodsInfoDto, PartnerCategoryList } from '@/api/industryMall'
import { getPcGoodsCategoryList, getGoodsList, batchUpdatePackage, getStoreLevelManageList, modifyGoodsPriceSubmit } from '@/api/goodsModule'

@Component({
  name: 'contentModule',
  components: {
    customRadio,
    editGoodsCard
  }
})
export default class contentModule extends Mixins(scroll) {
  @Prop({ default: 1 }) flag!: number // 1 已上架 2：已下架
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  params = {
    pageIndex: 1,
    pageSize: 10,
    keyword: '',
    hierarchyId: '',
    companyId:''
  }
  refreshing = false
  loading = false
  finished = false
  // 一级分类
  active1Key = 0
  // 二级分类
  active2Key = 0
  // 三级分类
  active3Key = 0
  tabActive = 0
  tabs: PartnerCategoryList[] = []
  category: PartnerCategoryList = {}
  goodsList: ShopGoodsInfoDto[] = []
  category3List: PartnerCategoryList[] = []
  show = false
  contentOverlayShow = false
  packageIdList: Array<string> = [] // 选择的套餐id集合
  levelList: Array<any> = []
  specsValue = 1
  checkAll = false
  checkAllValue = false

  get indeterminate () {
    let allIds: Array<string> = []
    this.goodsList.forEach(goods => {
      const filterPackages = goods.goodsPackageList.filter(p => p.packageStatus === this.flag)
      allIds.push(...filterPackages.map(i => i.packageId))
    })
    this.checkAllValue = this.packageIdList.length > 0 && this.packageIdList.length === allIds.length
    return this.packageIdList.length > 0 && this.packageIdList.length !== allIds.length
  }

  //
  get category2List () {
    const obj = {
      categoryId: '1',
      categoryName: '全部',
      children: [],
      hierarchyId: this.getHierarchyId(this.tabs[this.tabActive].hierarchyId)
    }
    return this.tabs[this.tabActive].children && [obj, ...this.tabs[this.tabActive].children] || []
  }

  handleClickOverlay() {
    this.contentOverlayShow = false
  }

  categoryClick(index) {
    this.active1Key = index
    this.getCategory(index)
    this.show = false
  }

  popupClick() {
    this.contentOverlayShow = false
    this.show = true
  }

  created() {
    this.params.companyId = this.companyId
    this.init()
    this.getStoreLevelManageList()
  }

  mounted () {
    this.$addScrollListener('.scroll-container')
  }

  activated() {
    window.localStorage.getItem('modifyPriceIndex')
    if (parseInt(window.localStorage.getItem('modifyPriceIndex')) > -1) {
      this.getModifyGoodsInfo('', parseInt(window.localStorage.getItem('modifyPriceIndex')))
      window.localStorage.setItem('modifyPriceIndex', '-1')
    }
    this.$setScrollY()
  }

  deactivated () {
    this.$removeScrollListener()
  }

  async init() {
    await this.getPartnerCategoryList()
    this.params.hierarchyId = this.getHierarchyId(this.category.hierarchyId)
    this.getCyStoreGoodsList()
  }

  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getCyStoreGoodsList()
  }

  onLoad() {
    this.params.pageIndex++
    this.getCyStoreGoodsList()
  }

  dataInit() {
    this.params.pageIndex = 1
    this.goodsList = []
  }

  resetData () {
    this.checkAll = false
    this.checkAllValue = false
    this.packageIdList = []
  }

  /**
   * 去历史记录页
   */
  toHistory() {
    this.$router.push({
      path: '/MallSearchHistory',
      query: {
        searchType: '1'
      }
    })
  }

  /**
   * 获取商品列表
   * @param {boolean} dataInit 是否初始化数据
   */
  getCyStoreGoodsList(dataInit = false) {
    dataInit && this.dataInit()
    getGoodsList({ ...this.params, packageStatus: this.flag, storeId: this.params.companyId })
      .then((res) => {
        if (this.refreshing) {
          this.resetData()
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      })
  }

  filterCategoryList(list: Array<any>) {
    return list.filter((item) => {
      if (item.children) {
        item.children = this.filterCategoryList(item.children)
      }
      return Number(item.goodsCount) !== 0
    })
  }

  /**
   * 获取合作方下产业商城分类-新
   */
  async getPartnerCategoryList() {
    try {
      let res = await getPcGoodsCategoryList({
        isPage: false,
        pageIndex: 1,
        pageSize: 10000,
        categoryLevel: 0,
        storeId: this.companyId
      })
      const allObj = {
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: ''
      }
      this.tabs = [allObj, ...this.filterCategoryList(res.data)]
      console.log('this.tabs ***', this.tabs)
      this.category = this.tabs[0]

      if (this.category.children && this.category.children[0]) {
        // 筛选三级分类a
        this.category3List =
          this.category.children[0].children &&
          this.category.children[0].children.map((item) => item)
        this.category3List && this.category3List.unshift({
          categoryId: '1',
          categoryName: '全部',
          hierarchyId: this.getHierarchyId(this.category.children[0].hierarchyId)
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 一级分类点击
  getCategory(index: number) {
    // if (this.active === index) return false
    this.category = this.tabs[index]

    // this.active = index
    this.tabActive = index
    this.active2Key = 0
    this.active3Key = 0
    // 一级切换每次都请求第一个二级分类
    if (this.category.children && this.category.children.length) {
      this.params.hierarchyId = this.getHierarchyId(this.category2List[0].hierarchyId)
    } else {
      this.params.hierarchyId = this.getHierarchyId(this.category.hierarchyId)
    }
    this.category3List = []
    if (this.category.children && this.category2List[0] && this.category2List[0].children && this.category2List[0].children.length) {
      // 筛选三级级分类
      // @ts-ignore
      this.category3List = this.category2List[0].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.getHierarchyId(this.category2List[0].hierarchyId)
      })
    }
    this.getCyStoreGoodsList(true)
  }

  // 二级分类点击
  getCategory2(index: number) {
    // if (this.activeKey === index) return false
    this.active2Key = index
    this.active3Key = 0

    this.params.hierarchyId = this.getHierarchyId(this.category2List[index].hierarchyId)
    this.category3List = []
    // @ts-ignore
    if (this.category2List.length && this.category2List[index].children && this.category2List[index].children.length) {
      // 筛选三级分类
      // @ts-ignore
      this.category3List = this.category2List[index].children && this.category2List[index].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.getHierarchyId(this.category2List[index].hierarchyId)
      })
    }

    this.getCyStoreGoodsList(true)
  }

  handle3Category(item, index) {
    // if (this.active3Key === index) return
    this.active3Key = index
    this.params.hierarchyId = this.getHierarchyId(item.hierarchyId)
    this.getCyStoreGoodsList(true)
    this.contentOverlayShow = false
  }

  getHierarchyId (id: string) {
    if (id) {
      const arr = id.split('.')
      return arr[arr.length - 1]
    }
    return ''
  }

  handlePackageList (ids: Array<string>, isAdd = false) {
    ids.forEach(id => {
      const targetIndex = this.packageIdList.findIndex(packageId => packageId === id)
      if (isAdd) {
        if (targetIndex === -1) this.packageIdList.push(id)
      } else {
        if (targetIndex > -1) this.packageIdList.splice(targetIndex, 1)
      }
    })
    console.log('handlePackageList ***', this.packageIdList)
  }

  // 上架或下架
  onShelve () {
    if (this.packageIdList.length === 0) {
      // this.$toast('请至少选择一条数据！')
      this.$toast({
        message: `请先选择需要${ this.flag === 1 ? '下架' : '上架'}的商品`,
        icon: 'warning-o',
        // icon: 'passed',
        className: 'customize-toast'
      })
    } else {
      const params = {
        isUpShelves: this.flag === 1 ? 2 : 1,
        packageIdList: this.packageIdList.map(packageId => {
          return { packageId }
        }),
        storeId: this.companyId
      }
      this.$dialog.confirm({
          message: `确定批量${ this.flag === 1 ? '下架' : '上架'}？`,
        })
        .then(() => {
          batchUpdatePackage(params).then(res => {
            this.packageIdList = []
            this.checkAll = false
            this.$toast({
              message: res.msg,
              icon: 'passed',
              className: 'customize-toast'
            })
            this.onRefresh()
          })
        })
    }
  }

  getStoreLevelManageList () {
    const params = {
      storeId: this.companyId,
      isPage: 1,
      pageIndex: 1,
      pageSize: 1000
    }
    getStoreLevelManageList(params).then(res => {
      this.levelList = res.data.records.map(item => {
        item.finalPriceCopy = this.specsValue * item.buyDiscount
        item.finalPrice = this.specsValue * item.buyDiscount
        item.buyDiscount = (item.buyDiscount * 100).toFixed()
        item.buyDiscountCopy = item.buyDiscount
        item.buySubtract = ''
        item.buySubtractCopy = item.buySubtract
        return { ...item }
      })
    })
  }

  changeVal (specsValue: number) {
    // @ts-ignore
    // this.specsValue = this.specsValue.replace(/[^\d.]/g, '')
    this.specsValue = specsValue
    this.levelList = this.levelList.map(item => {
      if (item.buyDiscountCopy) {
        item.finalPriceCopy = this.specsValue * item.buyDiscountCopy / 100 + ''
      }
      if (item.buySubtractCopy) {
        item.finalPriceCopy = ((this.specsValue * 1000) - (item.buySubtractCopy * 1000)) / 1000 + ''
      }
      item.finalPrice = this.specsValue * item.buyDiscount
      return { ...item }
    })
  }

  blurVal (packageId: string, idx: number) {
    let flag = true
    let levelPriceList = this.levelList.map(item => {
      if (Number(this.specsValue) === Number(item.buySubtractCopy)) {
        flag = false
      }
      if (item.finalPriceCopy <= 0) {
        flag = false
      }

      return {
        levelId: item.levelId,
        packageId,
        buyDiscount: item.buyDiscountCopy && item.buyDiscountCopy / 100,
        buySubtract: item.buySubtractCopy
      }
    })
    if (!flag) {
      this.$toast({
        message: '价格修改失败\n(存在优惠后小于等于0元的商品套餐)',
        icon: 'close',
        className: 'customize-toast'
      })
      return false
    }
    modifyGoodsPriceSubmit({
      packageId,
      marketPrice: this.specsValue,
      // levelPriceList
    }).then(res => {
      this.$toast({
        message: '价格修改成功\n(差异定价同步更新)',
        icon: 'passed',
        className: 'customize-toast'
      })
      // this.onRefresh()
      this.getModifyGoodsInfo(packageId, idx)
    })
  }

  // 获取修改价格的商品信息
  getModifyGoodsInfo (packageId: string, index: number) {
    // @ts-ignore
    const pageIndex = parseInt(index / 10) + 1
    const dataIndex = index % 10
    getGoodsList({ ...this.params, pageIndex, packageStatus: this.flag, storeId: this.params.companyId })
      .then((res) => {
        // @ts-ignore
        this.$set(this.goodsList[index], 'goodsPackageList', res.data.records[dataIndex].goodsPackageList)
      })
  }
}
